<template>

	<ul class="filter-groups">

		<li class="filter-groups__item" v-for="(group, index) in groups" :key="group.title">

			<filter-group v-bind:groupIndex="index" v-bind:id="group.id" v-bind:groupKey="group.key" v-bind:title="group.title" v-bind:options="group.options"></filter-group>

		</li>

	</ul>

</template>

<script>
import FilterGroup from './filter-group.vue'

export default {
	computed: {
		groups () {
			// Get filtered jobs
			// const jobs = this.$store.getters.filteredJobs
			const arr  = []

			// Loop through filter groups
			for (const g of this.$store.state.filterGroups) {

				// Array for holding available options
				const availableOptions = []

				// Loop through options in group
				for (let o of g.options) {

					// Check number of jobs available for this filter option
					let num = 0

					if (this.$store.state.filteringBy === g.key) {

						let candidates = this.$store.state.candidates

						for (const ft in this.$store.state.selectedFilters) {

							for (const fv of this.$store.state.selectedFilters[ft]) {

								const valueToCompare = (ft === g.key) ? o.value : fv
								const propertyToUse  = (ft === 'terms') ? 'title' : ft

								if (ft === 'terms') {
									const fLower = fv.toLowerCase()
									candidates = candidates.filter((item) => {
										const t = item.title.toLowerCase()
										return t.includes(fLower)
									})
								} else {
									candidates = candidates.filter((item) => {return item[propertyToUse].includes(valueToCompare)})
								}
							}
						}

						num = candidates.length

					} else {

						for (const j of this.$store.getters.filteredCandidates) {

							if (j[g.key].includes(o.value)) {
								num++
							}
						}
					}

					// Add number of candidates as property to filter object
					o.candidates = num

					// Add filter object to available options
					availableOptions.push(o)
				}

				if (availableOptions.length) {
					arr.push({
						id: g.id,
						title: g.title,
						key: g.key,
						options: availableOptions
					})
				}
			}

			return arr

			// return this.$store.state.filterGroups
		}
	},
	components: {
		FilterGroup
	}
}
</script>
